<mat-card-title [routerLink]="['/entrada',curso.id]">
        <span>{{curso.titulo}}</span>  
       
  
</mat-card-title>
<br>
<!-- <mat-card-content [routerLink]="['/entrada',curso.id]">
   <p>
       {{curso.content | contenido}}
   </p>
</mat-card-content> -->
<mat-card-footer [routerLink]="['/entrada',curso.id]" id="foter">
    <!-- <mat-chip-list>
        <mat-chip selected *ngFor="let tag of curso.tags" [ngClass]="tag">
            {{tag}}
        </mat-chip>
    </mat-chip-list>
    <span class="fill-remaining-space"></span>
    <span id="ventas" title="{{contador}} Vistas">{{contador}} <i class="fa fa-eye" aria-hidden="true"></i></span> -->
    <p>Por {{curso.creador}}</p>
   <!--  <button mat-button id="btnComprar" [routerLink]="['/curso',curso.id]">Lo Quiero!</button>  -->
     
</mat-card-footer>
